import { NextPage } from 'next'
import Image from 'next/legacy/image'

import StoreLayout from './../components/StoreLayout'
import { t } from '../../../utils'
import StoreProductTabs, {
  StoreItemTypeEnum
} from './components/StoreProductTabs'
import StoreProductsBanner from './components/StoreProductsBanner'

import multiTrackBannerImg from '@public/images/store/products_multitracks_banner.png'
import TryItBlock from '../components/TryItBlock'
import multitrackImg from '@public/images/store/product-multi-tracks.png'
import ProductsContent from './components/ProductsContent'

const StoreProductsMultiTracks: NextPage & {
  theme?: string
} = () => {
  return (
    <StoreLayout
      pageTitle={t('MultiTracks & Stems - Worship Online')}
      pageDescription={t(
        'Download Multitracks for worship in any key. Use them for running tracks live or to rehearse your parts for Sunday.'
      )}
    >
      <StoreProductsBanner title={t('Multi Tracks')}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="112"
          height="88"
          viewBox="0 0 112 88"
        >
          <g>
            <g>
              <g>
                <path
                  fill="#fff"
                  d="M89.212 25.755c9.142 0 16.582 7.44 16.582 16.582v23.116c0 9.142-7.44 16.582-16.582 16.582H22.625c-9.142 0-16.581-7.44-16.581-16.582V42.337c0-9.142 7.44-16.582 16.58-16.582zm22.625 39.698V42.337c0-12.476-10.149-22.625-22.625-22.625H22.625C10.149 19.712 0 29.86 0 42.337v23.116C0 77.93 10.15 88.078 22.625 88.078h66.587c12.476 0 22.625-10.149 22.625-22.625z"
                />
              </g>
              <g>
                <path
                  fill="#fff"
                  d="M88.513 15.9H23.324a3.023 3.023 0 0 1 0-6.043h65.19a3.022 3.022 0 1 1 0 6.043z"
                />
              </g>
              <g>
                <path
                  fill="#fff"
                  d="M74.47 6.044H37.367a3.022 3.022 0 1 1 0-6.044H74.47a3.023 3.023 0 0 1 0 6.044z"
                />
              </g>
              <g>
                <path
                  fill="#fff"
                  d="M67.786 53.894L46.513 64.678V43.114zM43.491 72.617c.47 0 .937-.109 1.366-.327l30.98-15.7a3.02 3.02 0 0 0 0-5.391l-30.98-15.7a3.02 3.02 0 0 0-4.388 2.696v31.4a3.024 3.024 0 0 0 3.022 3.022z"
                />
              </g>
            </g>
          </g>
        </svg>
        <Image
          src={multiTrackBannerImg}
          alt={`Multi Tracks background image`}
          priority={true}
          layout="fill"
          objectFit="cover"
        ></Image>
        <Image src={multitrackImg} alt="multitrack products" />
      </StoreProductsBanner>
      <ProductsContent>
        <p>
          {t(`Are you ready to have some of the best musicians in the world playing alongside you this Sunday? Multi Tracks are each of the individual audio tracks that make up the mix of a
song.`)}
        </p>
        <p>
          {t(
            `If your band runs tracks on Sunday, or if you want to start, this is your one-stop shop for all of your track needs. You can download multi-tracks in any key, use them to isolate tracks for practice, and also run them live to enhance your band’s sound.`
          )}
        </p>
      </ProductsContent>
      <StoreProductTabs tab={StoreItemTypeEnum.MultiTracks} />
      <TryItBlock />
    </StoreLayout>
  )
}

StoreProductsMultiTracks.theme = 'dark'
export default StoreProductsMultiTracks
